import React from 'react'
import { useTranslation } from 'react-i18next'
import { Image } from '@fs/zion-ui'
import { isTranslationAvailable } from '@fs/zion-locale'
import svg from './Memories.svg'

export default function NoMemories() {
  const [t] = useTranslation()
  const altTextKey = isTranslationAvailable('info-cards.no-memories.label')
    ? 'info-cards.no-memories.label'
    : 'info-cards.memories.header'
  return <Image height="170px" width="100%" style={{ margin: '16px 0 20px 0' }} src={svg} alt={t(altTextKey)} />
}
